import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works-container">
        <h2 className="how-it-works-title">Kako deluje</h2>
        <div className="how-it-works-line"></div>
        <p className="how-it-works-description">
          Objava oglasa je hitra in preprosta! Sledite tem trem preprostim korakom in začnite prodajati svoje izdelke še danes.
        </p>
        <div className="how-it-works-steps">
          <div className="step-box">
            <div className="step-icon">1</div>
            <h3>Ustvari račun</h3>
            <p>Prijavite se v le nekaj klikih in začnite svojo prodajno pot.</p>
          </div>
          <div className="step-box">
            <div className="step-icon">2</div>
            <h3>Objavi oglas</h3>
            <p>Navedite podrobnosti o svojem artiklu, naložite slike in določite ceno.</p>
          </div>
          <div className="step-box">
            <div className="step-icon">3</div>
            <h3>Prodaj stvar</h3>
            <p>Povežite se s kupci in sklenite posel. Tako preprosto je!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;